import { COMPANY } from "../mock";
import { Reveal } from "./Reveal";

export const IntroBanner = () => (
  <section data-testid="intro-banner" className="relative bg-gradient-to-br from-[#0e4a2c] via-[#145a36] to-[#1b7a46] overflow-hidden">
    <div className="absolute inset-0 flex flex-col justify-center gap-2">
      <span className="watermark-text text-[17vw] leading-none -rotate-2 translate-x-6">Napolano Impianti</span>
      <span className="watermark-text text-[17vw] leading-none rotate-1 -translate-x-10">Senza pensieri</span>
    </div>
    <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <Reveal>
        <h2 className="font-condensed font-extrabold uppercase text-white text-3xl sm:text-4xl tracking-tight mb-8">
          Manutenzione senza pensieri
        </h2>
      </Reveal>
      <div className="space-y-6 text-white/90 text-base sm:text-lg leading-relaxed">
        <Reveal delay={0.1}>
          <p>
            {COMPANY.name} è il punto di riferimento per chi desidera avere sempre un professionista affidabile
            per la manutenzione della propria casa o attività commerciale. {COMPANY.servicesSummary.charAt(0).toUpperCase() + COMPANY.servicesSummary.slice(1)},
            piccole riparazioni quotidiane e lavori più complessi: interveniamo con professionalità, rapidità ed
            esperienza, offrendo soluzioni pratiche per ogni esigenza. Montaggi, sistemazioni, manutenzioni
            ordinarie, interventi tecnici e assistenza continua diventano finalmente semplici da gestire grazie a
            un servizio costruito su misura per chi non vuole perdere tempo tra mille contatti e imprevisti.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p>
            Con la {COMPANY.productName} ti basta scegliere il pacchetto più adatto alle tue necessità per avere un
            professionista sempre a disposizione durante tutto l'anno, pronto ad aiutarti quando serve davvero.
            Che si tratti di un piccolo intervento domestico, della manutenzione di un ufficio, di un negozio o di
            qualsiasi altra esigenza tecnica, {COMPANY.shortName} rappresenta la soluzione pratica, veloce e
            affidabile per vivere e lavorare senza pensieri. Perché la tranquillità nasce anche dal sapere che
            c'è sempre qualcuno pronto a risolvere ogni problema.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
